// ticketingSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { viewTickets, getIssues, createTicket, getId } from "../config";
import {
  csrRegistration,
  getStatus,
  partnershipRegistration,
  sponsorshipRegistration,
} from "../../../configs/WebServiceUrl";

// Get tickets list
export const getTicketsList = createAsyncThunk(
  "ticketing/getTicketsList",
  async ({ user_id }) => {
    const response = await axios.get(`${viewTickets}/${user_id}`);
    console.log(response);
    return response.data || response.data?.data;
  },
);

// Get issues
export const getIssuesList = createAsyncThunk(
  "ticketing/getIssuesList",
  async () => {
    const res = await axios.get(getIssues);
    return res?.data?.map((i) => ({
      id: i.id,
      label: i.issue,
      parent_id: i.parent_issue_id,
    }));
  },
);

export const getuserIdByPhoneNumber = createAsyncThunk(
  "ticketing/getuserIdByPhoneNumber",
  async (mobile_number, { rejectWithValue }) => {
    try {
      const res = await axios.post(getId, {
        mobile_number: mobile_number,
      });

      return res?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getStatusAPI = createAsyncThunk(
  "ticketing/getStatusAPI",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${getStatus}${id}`);
      const { data } = res.data || {};
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const sponsorshipRegistrationThunk = createAsyncThunk(
  "ticketing/sponsorshipRegistrationThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(sponsorshipRegistration, payload);
      console.log("res", JSON.stringify(res));
      console.log("res data", JSON.stringify(res?.data));
      return res.data; // must contain message
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);
export const partnershipRegistrationThunk = createAsyncThunk(
  "ticketing/partnershipRegistrationThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(partnershipRegistration, payload);
      console.log("res", JSON.stringify(res));
      console.log("res data", JSON.stringify(res?.data));
      return res.data; // must contain message
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);
export const csrRegistrationThunk = createAsyncThunk(
  "ticketing/csrRegistrationThunk",
  async (payload, { rejectWithValue }) => {
    console.log("csr payload", JSON.stringify(payload));
    try {
      const res = await axios.post(csrRegistration, payload);
      console.log("res", JSON.stringify(res));
      console.log("res data", JSON.stringify(res?.data));
      return res.data; // must contain message
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

// Create ticket
// export const createTicketThunk = createAsyncThunk(
//   "ticketing/createTicket",
//   async (
//     { user_id, email, lastId, issue_description, files, mobile_number },
//     { dispatch },
//   ) => {
//     const data = {
//       user_id: user_id,
//       issue_id: lastId,
//       description: issue_description,
//       email: email,
//       mobile_number: mobile_number,
//     };
//     console.log("data", JSON.stringify(data));
//     const formData = new FormData();
//     formData.append(
//       "ticketData",
//       JSON.stringify({
//         // user_id: userData?.admin_id || null,
//         // issue_id: lastId,
//         // description: issue_description,
//         // email: userData?.email,
//         // mobile_number: mobile_number,
//         user_id: user_id,
//         issue_id: lastId,
//         description: issue_description,
//         email: email,
//         mobile_number: mobile_number,
//       }),
//     );
//     files.forEach((f) => formData.append("files", f));

//     console.log("🚀 FormData being sent:");
//     for (const [key, value] of formData.entries()) {
//       if (value instanceof File) {
//         console.log(key, {
//           name: value.name,
//           size: value.size,
//           type: value.type,
//         });
//       } else {
//         console.log(key, value);
//       }
//     }
//     const res = await fetch(createTicket, { method: "POST", body: formData });
//     console.log("res", JSON.stringify(res));
//     const json = await res.json();
//     console.log("json", JSON.stringify(json));
//     // if (userData?.admin_id) {
//     //   await dispatch(getTicketsList({ user_id: userData?.id }));
//     // }
//     return json;
//   },
// );
export const createTicketThunk = createAsyncThunk(
  "ticketing/createTicket",
  async (
    { user_id, email, lastId, issue_description, files, mobile_number },
    { rejectWithValue },
  ) => {
    const payload = {
      user_id,
      issue_id: lastId,
      description: issue_description,
      email,
      mobile_number,
    };

    const formData = new FormData();
    formData.append("ticketData", JSON.stringify(payload));
    files.forEach((f) => formData.append("files", f));
    for (const [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(key, {
          name: value.name,
          size: value.size,
          type: value.type,
        });
      } else {
        console.log(key, value);
      }
    }
    try {
      const res = await axios.post(createTicket, formData);
      const json = res.data;
      return json;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  },
);

const ticketSlice = createSlice({
  name: "ticketsMgt",
  initialState: {
    ticketsList: null,
    issues: [],
    data: {
      list: { initial_list: [] },
      selected_values: {},
      files: [],
      issue_description: "",
      loader: false,
    },
    error: "",
    countDetailsStatus: "idle",
    countDetailsError: null,
    ticketsListStatus: "idle",
    ticketsListError: null,
    issuesStatus: "idle",
    issuesError: null,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    updateList: (state, action) => {
      const { parentId, key } = action.payload;
      const filtered = state.issues.filter(
        (i) =>
          (parentId == null && i.parent_id == null) || i.parent_id === parentId,
      );
      state.data.list[key] = filtered;
    },
    handleInputChangeRedux: (state, action) => {
      const { option, key, listKey } = action.payload;
      const selected = { ...state.data.selected_values };
      Object.keys(selected)
        .filter((k) => k > key)
        .forEach((k) => delete selected[k]);

      const newList = Object.fromEntries(
        Object.entries(state.data.list).filter(
          ([k]) => !Object.keys(selected).includes(k),
        ),
      );

      state.data.selected_values = { ...selected, [key]: option };
      state.data.list = newList;

      if (option) {
        const filtered = state.issues.filter(
          (i) =>
            (option.id == null && i.parent_id == null) ||
            i.parent_id === option.id,
        );
        state.data.list[listKey] = filtered;
      }
    },
    addFiles: (state, action) => {
      state.data.files = [...state.data.files, ...action.payload];
    },
    removeFile: (state, action) => {
      state.data.files.splice(action.payload, 1);
    },

    // ✅ NEW resetData reducer
    resetData: (state) => {
      state.data = {
        list: { initial_list: state.issues.filter((i) => i.parent_id == null) },
        selected_values: {},
        files: [],
        issue_description: "",
        loader: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketsList.pending, (state) => {
        state.ticketsListStatus = "loading";
      })
      .addCase(getTicketsList.fulfilled, (state, action) => {
        state.ticketsListStatus = "succeeded";
        state.ticketsList = action.payload;
      })
      .addCase(getTicketsList.rejected, (state, action) => {
        state.ticketsListStatus = "failed";
        state.ticketsListError =
          action.payload || action.error?.message || null;
      })
      .addCase(getIssuesList.pending, (state) => {
        state.issuesStatus = "loading";
      })
      .addCase(getIssuesList.fulfilled, (state, action) => {
        state.issuesStatus = "succeeded";
        state.issues = action.payload;
        state.data.list.initial_list = action.payload.filter(
          (i) => i.parent_id == null,
        );
      })
      .addCase(getIssuesList.rejected, (state, action) => {
        state.issuesStatus = "failed";
        state.issuesError = action.error?.message;
      })
      .addCase(createTicketThunk.pending, (state) => {
        state.data.loader = true;
      })
      .addCase(createTicketThunk.fulfilled, (state) => {
        state.data.loader = false;
      })
      .addCase(createTicketThunk.rejected, (state) => {
        state.data.loader = false;
      });
  },
});

export const {
  setError,
  updateData,
  updateList,
  handleInputChangeRedux,
  addFiles,
  removeFile,
  resetData,
} = ticketSlice.actions;
export default ticketSlice.reducer;
